export default __webpack_public_path__ + "locales/zh-CN/DeleteThirdPartyDialog.json?hash=83d45baae5209fe9edae707446080163";